import { Box, Button, Grid, Paper, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import SimpleModal from 'src/Component/SimpleModal'
import { useGetCommentsListByIdQuery, useGetPostDetailsByIdQuery } from 'src/api/postsApi'
import { AppDispatch } from 'src/store'
import { startPageLoader, stopPageLoader } from 'src/store/features/common/commonSlice'
import SingleComment from './SingleComment'
import InfiniteScroll from 'react-infinite-scroll-component'
import { comment, postMedia } from 'src/api/postsApi/types'
import Carousel from 'react-material-ui-carousel'

type ViewPostDetailsProps = {
  id: number
  open: boolean
  onClose: () => void
  onDeleteClick: (id: number) => void
}
const ViewPostDetails = ({ id, open, onClose, onDeleteClick }: ViewPostDetailsProps) => {
  const dispatch = useDispatch<AppDispatch>()
  const {
    data,
    isFetching,
    refetch,
    isSuccess: postFetchedSuccessfully,
  } = useGetPostDetailsByIdQuery(id)
  const [page, setPage] = useState<number>(1)
  const [comments, setComments] = useState<comment[]>([])
  const [postMedia, setPostMedia] = useState<postMedia[]>([])
  const [hasMore, setHasMore] = useState(false)

  const { data: POST_COMMENTS_RESPONSE, isSuccess: commentsFetchedSuccessfully } =
    useGetCommentsListByIdQuery(
      {
        id,
        page,
        pageSize: 20,
      },
      { refetchOnMountOrArgChange: true },
    )

  useEffect(() => {
    if (isFetching) {
      dispatch(startPageLoader())
    } else {
      dispatch(stopPageLoader())
    }
  }, [isFetching])

  useEffect(() => {
    if (commentsFetchedSuccessfully) {
      setComments((prevComments) => [...prevComments, ...(POST_COMMENTS_RESPONSE?.results ?? [])])
      setHasMore(POST_COMMENTS_RESPONSE?.next !== null)
    }
  }, [commentsFetchedSuccessfully, POST_COMMENTS_RESPONSE])

  useEffect(() => {
    if (postFetchedSuccessfully) {
      setPostMedia(data?.post_media)
    }
  }, [postFetchedSuccessfully])

  const fetchReviewData = () => {
    setPage(page + 1)
  }

  console.log('postMedia', postMedia)
  return (
    <Box>
      <SimpleModal open={!!(open && id)} onClose={onClose}>
        {!!data && (
          <Box>
            <Grid container mt={3}>
              <Grid xs={12}>
                {postMedia.length === 0 ? (
                  <Typography variant='body1' style={{ color: 'grey' }}>
                    No Media yet.
                  </Typography>
                ) : (
                  <Carousel>
                    {postMedia.map((media) => {
                      if (media.is_media_video === true) {
                        return (
                          <div key={media.id}>
                            <video controls width='100%'>
                              <source src={media.media_file} type='video/mp4' />
                              <source src={media.media_file} type='video/webm' />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                        )
                      }
                      if (media.is_music === true) {
                        return (
                          <div key={media.id}>
                            <Grid
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '300px',
                              }}
                            >
                              <audio controls style={{ width: '80%' }}>
                                <source src={media.media_file} type='audio/mp3' />
                                Your browser does not support the audio tag.
                              </audio>
                            </Grid>
                          </div>
                        )
                      }
                      if (media.is_media_video === false && media.is_music === false) {
                        return (
                          <div key={media.id}>
                            <img
                              src={media.media_file}
                              alt={`Media ${media.id}`}
                              style={{ width: '100%', height: '300px', objectFit: 'cover' }}
                            />
                          </div>
                        )
                      }
                      return null
                    })}
                  </Carousel>
                )}
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Date:</Typography>
              </Grid>
              <Grid xs={3}>
                <Typography variant='h5'>{data.posted_at_view}</Typography>
              </Grid>
              <Grid xs={3}>
                <Typography variant='h4'>Author:</Typography>
              </Grid>
              <Grid xs={3}>
                <Typography variant='h5'>{`${data.posted_by.first_name} ${data.posted_by.last_name}`}</Typography>
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Caption:</Typography>
              </Grid>
              <Grid xs={9}>
                {data.caption ? (
                  <Typography variant='h5'>{data.caption}</Typography>
                ) : (
                  <Typography variant='body1' style={{ color: 'grey' }}>
                    No caption available.
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Description:</Typography>
              </Grid>
              <Grid xs={9}>
                {data.description ? (
                  <Typography variant='h5'>{data.description}</Typography>
                ) : (
                  <Typography variant='body1' style={{ color: 'grey' }}>
                    No description available.
                  </Typography>
                )}
              </Grid>
            </Grid>

            <Grid container mt={3} alignItems='center'>
              <Grid xs={3}>
                <Typography variant='h4'>Comments:</Typography>
              </Grid>
              <Grid xs={9}>
                {comments.length === 0 ? (
                  <Typography variant='body1' style={{ color: 'grey' }}>
                    No comments yet.
                  </Typography>
                ) : (
                  <InfiniteScroll
                    className='custom-scrollbar'
                    dataLength={comments.length}
                    next={fetchReviewData}
                    hasMore={hasMore}
                    loader={<h4>Loading...</h4>}
                    height={200}
                  >
                    {comments.map((comment) => (
                      <SingleComment
                        key={comment.id}
                        id={comment.id}
                        content={comment.content}
                        name={`${comment.comment_by.first_name} ${comment.comment_by.last_name}`}
                        profilePicture={comment.comment_by.profile_pic}
                      />
                    ))}
                  </InfiniteScroll>
                )}
              </Grid>
            </Grid>

            <Grid container mt={3}>
              <Button
                variant='contained'
                color='primary'
                type='button'
                onClick={() => onDeleteClick(id)}
              >
                DELETE
              </Button>
            </Grid>
          </Box>
        )}
      </SimpleModal>
    </Box>
  )
}

export default ViewPostDetails
